var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DeferredPromise, Delegate1 } from "flavr-common";
import { BufferState, sharedArrayService } from "./SharedArrayService";
export class SharedArray {
    constructor(type, targetWorkerId, uId) {
        this.type = type;
        this.targetWorkerId = targetWorkerId;
        this.uId = uId;
        this._bufferPromise = new DeferredPromise();
        this._offset = 0;
        this._isDestroyed = false;
        this.onBufferChangedDelegate = new Delegate1();
        this.onBufferCreated = (buffer) => {
            if (this._isDestroyed)
                return;
            this._buffer = buffer;
            this.headerUintArray = undefined;
            this._offset = 0;
            if (!(this._buffer instanceof ArrayBuffer)) {
                this.headerUintArray = this.createDataArray(Uint32Array, 1);
                this.numDirtyArray = this.createDataArray(Uint32Array, 1);
            }
            this._bufferPromise.resolve(buffer);
            this.onBufferChangedDelegate.invoke(this);
        };
        this.id = sharedArrayService.generateId();
        sharedArrayService.add(this);
    }
    get byteLength() {
        if (!this._buffer)
            return 0;
        return this._buffer.byteLength;
    }
    get buffer() {
        return this._buffer;
    }
    get offset() {
        return this._offset;
    }
    get isDestroyed() {
        return this._isDestroyed;
    }
    /**
     * const numDirty = sharedArray.numDirty;
     * if (numDirty !== 0) {
        geometry.attributes.position.needsUpdate = true;
        geometry.attributes.color.needsUpdate = true;
      }
      geometry.setDrawRange(0, numDirty);
      sharedArray.consumed();
     */
    get numDirty() {
        if (this.numDirtyArray) {
            return Atomics.load(this.numDirtyArray, 0);
        }
        return 0;
    }
    get isReady() {
        if (!this._buffer)
            return false;
        if (!this.headerUintArray)
            return false;
        return Atomics.load(this.headerUintArray, 0) === BufferState.Ready;
    }
    get isConsumed() {
        if (!this._buffer)
            return false;
        if (!this.headerUintArray)
            return false;
        return Atomics.load(this.headerUintArray, 0) === BufferState.Consumed;
    }
    destroy() {
        if (this._isDestroyed)
            return;
        this._isDestroyed = true;
        sharedArrayService.destroy(this);
        this.headerUintArray = undefined;
        this.numDirtyArray = undefined;
        this._buffer = undefined;
        this._offset = 0;
    }
    bufferPromise() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._bufferPromise.promise;
        });
    }
    createDataArray(type, length) {
        if (!this.buffer)
            throw new Error("Buffer was not created");
        if (this._offset + type.BYTES_PER_ELEMENT * length > this.buffer.byteLength) {
            throw new Error(`Buffer overflow`);
        }
        const array = new type(this.buffer, this._offset, length);
        this._offset += type.BYTES_PER_ELEMENT * length;
        return array;
    }
    consumed() {
        if (this.headerUintArray) {
            Atomics.store(this.headerUintArray, 0, BufferState.Consumed);
        }
        if (this.numDirtyArray) {
            Atomics.store(this.numDirtyArray, 0, 0);
        }
    }
}
